jQuery( document ).ready( function() {
	const post_id = jQuery( '.footer' ).attr( 'post-id' );
	jQuery.ajax( {
		url: localVars.ajax_url,
		type: 'post',
		data: {
			action: 'core_values',
			post_id,
			nonce: localVars.nonce,
		},
		success( response ) {
			jQuery( '.footer' ).prepend( response );
		},
	} );
} );
